import { TSelectOption } from '@interfaces/components/componentTypes';
import { IActionMenu } from '@interfaces/components/table';
import { IDownloadHistoryItem } from '@interfaces/downloadHistory/downloadHistoryDTO';

import { EMenuActionsTypes, TMenuActionsTypes } from '@enums/common';
import { EFileStatusTypes } from '@enums/downloadHistory';

import { menuActions } from '@constants/common';

export const getCustomActionsDownloadHistory = ({
	downloadHistory,
	selectedStatus,
	checkedIds,
}: {
	downloadHistory: IDownloadHistoryItem[];
	selectedStatus: TSelectOption<string> | null;
	checkedIds: string[];
}): IActionMenu<TMenuActionsTypes>[] => {
	return menuActions.map(action => {
		switch (action.id) {
			case EMenuActionsTypes.currentPage:
				return {
					...action,
					disabled: downloadHistory.every(file => file.status.name === EFileStatusTypes.failed),
				};
			case EMenuActionsTypes.allFiltered:
				return {
					...action,
					disabled: selectedStatus?.value === EFileStatusTypes.failed,
				};
			case EMenuActionsTypes.selected:
				return {
					...action,
					disabled: downloadHistory.filter(file => checkedIds.includes(file.id))
						.every(file => file.status.name === EFileStatusTypes.failed),
				};
			default:
				return action;
		}
	});
};
